import React from 'react'
import { getUrlParams } from '@Common/Services'
import { fetchAgency } from '../Pages/RequestQuote/Functions'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import RequestQuote from '../Pages/RequestQuote'
import { PageContent } from '../Components/PageContent'
import { useQuery } from '@tanstack/react-query'
import AppNotifications from '@Common/Components/Layout/AppNotifications'

export const App = () => {
  const agencyCode = getUrlParams('agency')
  const { isSuccess, data: agency = {} } = useQuery(['agencyInfo', agencyCode], fetchAgency(agencyCode), { enabled: !!agencyCode })

  return (
    <BrowserRouter basename='/'>
      <AppNotifications />
      <PageContent noCard customBackgroundUrl={!isSuccess ? false : (agency.customBackgroundAppointments || agency.customBackgroundUrl)}>
        <Routes>
          <Route path='/requestQuote/*' element={<RequestQuote />} />
        </Routes>
      </PageContent>
    </BrowserRouter>
  )
}
